/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ s: NonNullable<unknown>, ca: NonNullable<unknown> }} Actuator_Mismatch_ErrorInputs */



/**
* | output |
* | --- |
* | "Mismatch fault: run feedback {s} is different from controller command {ca}" |
*
* @param {Actuator_Mismatch_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_mismatch_error = /** @type {((inputs: Actuator_Mismatch_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Mismatch_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Mismatch fault: run feedback ${i?.s}
is different from controller command ${i?.ca}`)
	return /** @type {LocalizedString} */ (`Défaut de discordance : le retour de marche ${i?.s}
est différent de la commande l'automate ${i?.ca}`)
});